import React from 'react';
import { Button, Input } from 'reactstrap';

const ORDEM_SEMANA = ['segunda', 'terca', 'quarta', 'quinta', 'sexta', 'sabado', 'domingo'];

const semAcento = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const ordenarDiasSemana = (dias = []) => (
  [...dias].sort((a, b) => {
    const ia = ORDEM_SEMANA.findIndex((item) => semAcento(a.nome).startsWith(item));
    const ib = ORDEM_SEMANA.findIndex((item) => semAcento(b.nome).startsWith(item));
    return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
  })
);

const faixaVazia = () => ({ inicio: '', fim: '' });

export default function VagaHorarioKanban({
  dias = [],
  horariosPorDia = {},
  onChange,
  readOnly = false,
}) {
  const colunas = ordenarDiasSemana(dias);

  const atualizarDia = (diaId, faixas) => {
    onChange({
      ...horariosPorDia,
      [diaId]: faixas,
    });
  };

  if (!colunas.length) {
    return <p className="text-muted mb-3">Carregando os dias da semana...</p>;
  }

  return (
    <div style={{ overflowX: 'auto', paddingBottom: 8 }}>
      <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', minWidth: 'max-content' }}>
        {colunas.map((dia) => {
          const faixas = Array.isArray(horariosPorDia[dia.id]) ? horariosPorDia[dia.id] : [];
          return (
            <div
              key={dia.id}
              style={{
                width: 220,
                background: '#f7f9fb',
                border: '1px solid #d9e2ec',
                borderRadius: 8,
                padding: 10,
              }}
            >
              <div style={{ fontWeight: 600, marginBottom: 8 }}>{dia.nome}</div>
              {faixas.length === 0 && (
                <div className="text-muted small mb-2">Sem horário</div>
              )}
              {faixas.map((faixa, index) => (
                <div
                  key={`${dia.id}-${index}`}
                  style={{
                    background: '#fff',
                    border: '1px solid #e6e6e6',
                    borderRadius: 6,
                    padding: 8,
                    marginBottom: 8,
                  }}
                >
                  <label className="small mb-1 d-block">Entrada</label>
                  <Input
                    type="time"
                    bsSize="sm"
                    value={faixa.inicio || ''}
                    disabled={readOnly}
                    onChange={(event) => {
                      const next = faixas.map((item, itemIndex) => (
                        itemIndex === index ? { ...item, inicio: event.target.value } : item
                      ));
                      atualizarDia(dia.id, next);
                    }}
                  />
                  <label className="small mb-1 mt-2 d-block">Saída</label>
                  <Input
                    type="time"
                    bsSize="sm"
                    value={faixa.fim || ''}
                    disabled={readOnly}
                    onChange={(event) => {
                      const next = faixas.map((item, itemIndex) => (
                        itemIndex === index ? { ...item, fim: event.target.value } : item
                      ));
                      atualizarDia(dia.id, next);
                    }}
                  />
                  {!readOnly && (
                    <Button
                      type="button"
                      color="link"
                      size="sm"
                      className="px-0 mt-1"
                      onClick={() => atualizarDia(dia.id, faixas.filter((_, itemIndex) => itemIndex !== index))}
                    >
                      Remover
                    </Button>
                  )}
                </div>
              ))}
              {!readOnly && (
                <Button
                  type="button"
                  color="light"
                  size="sm"
                  className="w-100"
                  onClick={() => atualizarDia(dia.id, [...faixas, faixaVazia()])}
                >
                  Adicionar horário
                </Button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
